(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-garage-nav"] && !Shopify.designMode) return;
  try {
    
/**
 * My Garage Navigation Bar - Dynamic Content Update
 * Opens the shared modal from snippets/garage-modal.liquid
 */
(function() {
  const STORAGE_KEY = 'lps_my_garage';
  const contentEl = document.querySelector('[data-garage-bar-content]');
  const buttonTextEl = document.querySelector('[data-garage-button-text]');

  if (!contentEl || !buttonTextEl) {
    console.error('[Garage Bar] Required elements not found');
    return;
  }

  /**
   * Load garage data from localStorage
   */
  function loadGarage() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : { garage: [] };
    } catch (error) {
      console.error('Error loading garage data:', error);
      return { garage: [] };
    }
  }

  /**
   * Get active equipment from garage
   */
  function getActiveEquipment() {
    const data = loadGarage();
    return data.garage.find(item => item.isActive) || null;
  }

  /**
   * Update the garage bar content based on active equipment
   */
  function updateGarageBar() {
    const activeEquipment = getActiveEquipment();

    if (activeEquipment) {
      // Show "My Garage: Make Model (change)"
      contentEl.innerHTML = `
        <span class="garage-nav-bar__label">My Garage:</span>
        <span class="garage-nav-bar__equipment">${activeEquipment.make} ${activeEquipment.model}</span>
      `;
      buttonTextEl.textContent = 'Add Equipment';

      // Re-attach the trigger listener to the new "change" link
      const changeLink = contentEl.querySelector('[data-garage-trigger]');
      if (changeLink) {
        changeLink.addEventListener('click', openGarageModal);
      }
    } else {
      // Show "My Garage" only
      contentEl.innerHTML = '<span class="garage-nav-bar__label">My Garage</span>';
      buttonTextEl.textContent = 'Add Equipment';
    }
  }

  /**
   * Open garage modal (triggered by main button or change link)
   */
  function openGarageModal() {
    const modal = document.querySelector('[data-garage-modal]');
    if (modal) {
      modal.style.display = 'flex';
    }
  }

  // Attach click listener to main button
  const mainButton = document.querySelector('.garage-nav-bar__button');
  if (mainButton) {
    mainButton.addEventListener('click', openGarageModal);
  }

  // Listen for updates from the shared modal
  window.addEventListener('lpsGarageUpdate', updateGarageBar);

  // Initial update
  updateGarageBar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["my-garage"] && !Shopify.designMode) return;
  try {
    
/**
 * My Garage - Local Storage Management
 */
(function() {
  // Get config from JSON script tag
  const configScript = document.querySelector('[id^="garage-config-"]');
  if (!configScript) return;

  const config = JSON.parse(configScript.textContent);
  const STORAGE_KEY = 'lps_my_garage';
  const sectionId = config.sectionId;

  // DOM Elements
  const form = document.getElementById(`add-equipment-form-${sectionId}`);
  const makeSelect = document.getElementById(`equipment-make-${sectionId}`);
  const modelInput = document.getElementById(`equipment-model-${sectionId}`);
  const errorDiv = document.getElementById(`form-errors-${sectionId}`);
  const emptyState = document.getElementById(`garage-empty-${sectionId}`);
  const garageList = document.getElementById(`garage-list-${sectionId}`);

  /**
   * Generate unique ID for equipment items
   */
  function generateId() {
    return `eq_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  /**
   * Load garage data from localStorage
   */
  function loadGarage() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : { garage: [] };
    } catch (error) {
      console.error('Error loading garage data:', error);
      return { garage: [] };
    }
  }

  /**
   * Save garage data to localStorage
   */
  function saveToStorage(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      return true;
    } catch (error) {
      if (error.name === 'QuotaExceededError') {
        showError('Storage limit reached. Please remove some equipment.');
      } else {
        showError('Unable to save data. Please try again.');
      }
      console.error('Error saving garage data:', error);
      return false;
    }
  }

  /**
   * Show error message
   */
  function showError(message) {
    errorDiv.textContent = message;
    errorDiv.classList.add('visible');
    setTimeout(() => {
      errorDiv.classList.remove('visible');
    }, 5000);
  }

  /**
   * Sanitize user input to prevent XSS
   */
  function sanitize(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /**
   * Check if equipment already exists
   */
  function isDuplicate(make, model, garage) {
    return garage.some(item =>
      item.make.toLowerCase() === make.toLowerCase() &&
      item.model.toLowerCase() === model.toLowerCase()
    );
  }

  /**
   * Add equipment to garage
   */
  function addEquipment(make, model) {
    const data = loadGarage();

    // Check for duplicates
    if (isDuplicate(make, model, data.garage)) {
      showError('This equipment is already in your garage.');
      return false;
    }

    const newEquipment = {
      id: generateId(),
      make: sanitize(make),
      model: sanitize(model),
      isActive: data.garage.length === 0, // First item is active by default
      createdAt: new Date().toISOString()
    };

    data.garage.push(newEquipment);

    if (saveToStorage(data)) {
      renderGarageList();
      form.reset();
      return true;
    }
    return false;
  }

  /**
   * Remove equipment from garage
   */
  function removeEquipment(id) {
    const data = loadGarage();
    const index = data.garage.findIndex(item => item.id === id);

    if (index === -1) return false;

    const wasActive = data.garage[index].isActive;
    data.garage.splice(index, 1);

    // If removed item was active, set first item as active
    if (wasActive && data.garage.length > 0) {
      data.garage[0].isActive = true;
    }

    if (saveToStorage(data)) {
      renderGarageList();
      return true;
    }
    return false;
  }

  /**
   * Set equipment as active
   */
  function setActiveEquipment(id) {
    const data = loadGarage();

    // Deactivate all
    data.garage.forEach(item => {
      item.isActive = false;
    });

    // Activate selected
    const equipment = data.garage.find(item => item.id === id);
    if (equipment) {
      equipment.isActive = true;

      if (saveToStorage(data)) {
        renderGarageList();
        return true;
      }
    }
    return false;
  }

  /**
   * Render equipment list
   */
  function renderGarageList() {
    const data = loadGarage();
    const showIcons = config.showIcons;

    if (data.garage.length === 0) {
      emptyState.classList.remove('hidden');
      garageList.classList.add('hidden');
      return;
    }

    emptyState.classList.add('hidden');
    garageList.classList.remove('hidden');
    garageList.innerHTML = '';

    data.garage.forEach(equipment => {
      const itemDiv = document.createElement('div');
      itemDiv.className = `equipment-item${equipment.isActive ? ' active' : ''}`;
      itemDiv.setAttribute('data-id', equipment.id);

      const activeBadgeHTML = equipment.isActive ? `
        <span class="active-badge">
          ${showIcons ? `
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          ` : ''}
          Active
        </span>
      ` : '';

      itemDiv.innerHTML = `
        <div class="equipment-info">
          <span class="equipment-make">${equipment.make}</span>
          <span class="equipment-model">${equipment.model}</span>
          ${activeBadgeHTML}
        </div>
        <div class="equipment-actions">
          <button
            class="btn-set-active"
            data-id="${equipment.id}"
            ${equipment.isActive ? 'disabled' : ''}
            aria-label="Set ${equipment.make} ${equipment.model} as active"
          >
            ${config.setActiveButtonText}
          </button>
          <button
            class="btn-remove"
            data-id="${equipment.id}"
            aria-label="Remove ${equipment.make} ${equipment.model}"
          >
            ${config.removeButtonText}
          </button>
        </div>
      `;

      garageList.appendChild(itemDiv);
    });

    // Attach event listeners to buttons
    attachButtonListeners();
  }

  /**
   * Attach event listeners to equipment buttons
   */
  function attachButtonListeners() {
    // Set active buttons
    document.querySelectorAll(`#garage-list-${sectionId} .btn-set-active`).forEach(btn => {
      btn.addEventListener('click', function() {
        const id = this.getAttribute('data-id');
        setActiveEquipment(id);
      });
    });

    // Remove buttons
    document.querySelectorAll(`#garage-list-${sectionId} .btn-remove`).forEach(btn => {
      btn.addEventListener('click', function() {
        const id = this.getAttribute('data-id');
        if (confirm('Are you sure you want to remove this equipment?')) {
          removeEquipment(id);
        }
      });
    });
  }

  /**
   * Handle form submission
   */
  function handleFormSubmit(e) {
    e.preventDefault();

    const make = makeSelect.value.trim();
    const model = modelInput.value.trim();

    // Validation
    if (!make || !model) {
      showError('Please select a make and enter a model number.');
      return;
    }

    addEquipment(make, model);
  }

  /**
   * Check localStorage availability
   */
  function isLocalStorageAvailable() {
    try {
      const test = '__localStorage_test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (error) {
      return false;
    }
  }

  /**
   * Initialize
   */
  function init() {
    if (!isLocalStorageAvailable()) {
      showError('Local storage is not available. Your equipment will not be saved.');
      form.querySelector('button[type="submit"]').disabled = true;
      return;
    }

    // Render initial list
    renderGarageList();

    // Attach form submit listener
    if (form) {
      form.addEventListener('submit', handleFormSubmit);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose API for future filtering functionality
  window.LPSGarage = window.LPSGarage || {
    getActiveEquipment: function() {
      const data = loadGarage();
      return data.garage.find(item => item.isActive) || null;
    },
    getAllEquipment: function() {
      const data = loadGarage();
      return data.garage;
    },
    openGarageModal: function() {
      // Find the garage section and scroll to it
      const garageSection = document.getElementById(`my-garage-${sectionId}`);
      if (garageSection) {
        // Scroll to the garage section
        garageSection.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // Flash the form to draw attention
        const form = garageSection.querySelector('.garage-form');
        if (form) {
          form.style.transition = 'all 0.3s ease';
          form.style.boxShadow = '0 0 0 3px rgba(16, 185, 129, 0.5)';
          setTimeout(() => {
            form.style.boxShadow = '';
          }, 1500);
        }

        // Focus on the make select for accessibility
        if (makeSelect) {
          setTimeout(() => {
            makeSelect.focus();
          }, 500);
        }
      }
    }
  };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section-nav"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var nav = document.getElementById('product-section-nav');
    if (!nav) return;

    function getHeaderHeight() {
      var header = document.querySelector('.header-section, header.shopify-section');
      return header ? header.offsetHeight : 0;
    }

    function updateNavPosition() {
      var headerH = getHeaderHeight();
      nav.style.setProperty('--product-nav-top', headerH + 'px');
    }

    updateNavPosition();
    window.addEventListener('resize', updateNavPosition);

    var buttons = nav.querySelectorAll('[data-nav-target]');

    function getTotalOffset() {
      return getHeaderHeight() + nav.offsetHeight + 4;
    }

    buttons.forEach(function(btn) {
      var targetId = btn.getAttribute('data-nav-target');
      var target = document.getElementById(targetId);

      if (btn.hasAttribute('data-nav-conditional') && (!target || target.offsetHeight === 0)) {
        btn.classList.add('product-nav__btn--hidden');
        return;
      }

      btn.addEventListener('click', function() {
        var el = document.getElementById(targetId);
        if (!el) return;

        var top = el.getBoundingClientRect().top + window.scrollY - getTotalOffset();
        window.scrollTo({ top: top, behavior: 'smooth' });

        buttons.forEach(function(b) { b.classList.remove('product-nav__btn--active'); });
        btn.classList.add('product-nav__btn--active');
      });
    });

    var targets = [];
    buttons.forEach(function(btn) {
      if (btn.classList.contains('product-nav__btn--hidden')) return;
      var id = btn.getAttribute('data-nav-target');
      var el = document.getElementById(id);
      if (el) targets.push({ btn: btn, el: el });
    });

    var scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) return;
      scrollTimeout = requestAnimationFrame(function() {
        scrollTimeout = null;
        var offset = getTotalOffset();
        var scrollPos = window.scrollY + offset;

        var active = targets[0];
        for (var i = targets.length - 1; i >= 0; i--) {
          if (targets[i].el.offsetTop <= scrollPos) {
            active = targets[i];
            break;
          }
        }

        if (active) {
          buttons.forEach(function(b) { b.classList.remove('product-nav__btn--active'); });
          active.btn.classList.add('product-nav__btn--active');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
